<template>
  <div class="d-flex align-baseline flex-nowrap mb-2">
    <!-- Caption -->
    <div class="w-16 flex-shrink-0 caption text--secondary text-right">
      <slot name="caption"/>
    </div>

    <!-- Value -->
    <div class="flex-grow-1 pl-2 text--primary whitespace-pre-wrap break-all">
      <slot name="value"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CSummaryItem'
}
</script>
